import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { HttpService } from 'src/app/services/http.service';
import { LanguageService } from 'src/app/services/language.service';
import { UtilsService } from 'src/app/services/utils.service';
import { ErrorDialogData } from '../../modals/error-dialog-data';
import { ErrorDialogComponent } from '../../modals/error-dialog/error-dialog.component';
import { BikeUploadResultDialogData } from '../../modals/bulk-upload-result-dialog/bulk-upload-result-dialog-data';
import { BulkUploadResultDialogComponent } from '../../modals/bulk-upload-result-dialog/bulk-upload-result-dialog.component';

@Component({
  selector: 'app-recalled-upload',
  templateUrl: './recalled-upload.component.html',
  styleUrls: ['./recalled-upload.component.scss'],
  standalone: false
})
export class RecalledUploadComponent {

  /** Defining view or add release */
  public viewUploaded: boolean = false;
  public loading: boolean = false;

  public uploadedFileName: string = "";
  public uploadedSerials: string[] = [];

  public markStatus = [
    { Method: "recalled", DisplayName: this.languageService.languageJSON.ComponentRecalled_Recalled },
    { Method: "unrecalled", DisplayName: this.languageService.languageJSON.ComponentRecalled_Unrecalled }
  ];
  public selectedMarkStatus: string = "";

  constructor(public languageService: LanguageService, private httpService: HttpService,
    private router: Router, private matDialog: MatDialog, private utilsService: UtilsService) { }

  /** User uploading components serial numbers file by drag and dropping */
  public onFileDropped(event: any) {
    if (event[0].type == "text/csv" ||
      event[0].type == "application/vnd.ms-excel") {

      this.processFile(event[0]);
    }
    else {
      this.openErrorDialog(this.languageService.languageJSON.ComponentRecalledUploads_UploadListError, this.languageService.languageJSON.ComponentRecalledUploads_InvalidFileFormat);
    }
  }

  /** Parse .csv file to array */
  private processFile(file: any) {
    let reader = new FileReader();

    reader.addEventListener("load", () => {

      const reader = new FileReader();
      reader.readAsText(file);

      reader.onload = () => {
        this.viewUploaded = true;
        this.uploadedFileName = file.name;
        this.uploadedSerials = this.utilsService.parseCsvStringToArray(reader.result?.toString());
      };
    }, false);

    reader.readAsDataURL(file);
  }

  /** User uploading components serial numbers file by browsing a file */
  public recalledUpload(event: any) {
    const file = event.target.files[0];
    if (file) {
      this.processFile(file)
    }
  }

  /** Remove previously uploaded file data */
  public clearUpload(): void {
    this.viewUploaded = false;
    this.uploadedFileName = "";
    this.uploadedSerials = [];
  }

  /** Sending new release to the Api endpoint. */
  public onSubmit(): void {
    this.loading = true;
    switch (this.selectedMarkStatus) {
      case "recalled":
        this.httpService.recalledBulkUpload(this.uploadedSerials, "1").subscribe((resp: any) => {
          this.handleResponse(resp);
        });
        break;
      case "unrecalled":
        this.httpService.recalledBulkUpload(this.uploadedSerials, "0").subscribe((resp: any) => {
          this.handleResponse(resp);
        });
        break;
    }
  }

  private handleResponse(resp: any) {
    this.loading = false;
    if (resp?.success) {
      const data: BikeUploadResultDialogData = resp.data;
      this.matDialog.open(BulkUploadResultDialogComponent, { data: { data } });

      if (resp?.data.completed?.length > 0) {
        this.router.navigate(['/recalled-components']);
      }
    }
  }

  private openErrorDialog(title: string, message: string) {
    const data: ErrorDialogData = {
      title: title,
      message: message
    };
    this.matDialog.open(ErrorDialogComponent, { data: { data } });
  }

  public goBack() {
    this.router.navigate(['/recalled-components']);
  }
}
